<template>  
  <div class="dod-report-settings-holder">
    <d-button v-for="btn in buttons" :key="btn.id" :icon="btn.icon" :title="btn.tooltip" @click="btn.click"
      :disabled="btn.disabled" :variant="btn.active ? action_btn_variant_active : action_btn_variant_inactive"
      class="report-setting-button"></d-button>
  </div>
  <div class="relative d-relative">
    <d-overflow position="Left Right" ref="reportOverflow">
      <div ref="reportContainer">
        <d-loader></d-loader>
      </div>
    </d-overflow>
  </div>
  <div style="display:none">
    <d-svg id="report_bar_chart" :src="icons.report_icons.bar_chart"></d-svg>
    <d-svg id="report_pie_chart" :src="icons.report_icons.pie_chart"></d-svg>
  </div>
  <d-modal title="Graf" ref="graphModal">
        <d-row>
          <d-col cols="9">
            <d-chart :type="chart_type" :chart="chart_chart"></d-chart>
          </d-col>
          <d-col cols="3">
            <d-input-select v-model="chart_type" :items="all_chart_types"></d-input-select>
          </d-col>
        </d-row>
  </d-modal>  
</template>

<script setup>
import { ref, defineProps, onMounted, computed } from "vue";
import icons from "@/dod/enums/dicons";

const reportOverflow = ref("reportOverflow");

// Props for report & data URLs
const props = defineProps(["report_url", "data_url"]);
const reportContainer = ref(null);
const dodDrawer = ref(null); // Store dodDrawer globally in the component

const chart_type = ref(null);
const chart_chart = ref(null);
const graphModal = ref("graphModal");

const action_btn_variant_active = 'primary';
const action_btn_variant_inactive = 'outline-primary';

const is_decimals_visible = computed(() => {
  return dodDrawer.value ? dodDrawer.value.DecimalsVisible : false;
});
const is_accounts_visible = computed(() => {
  return dodDrawer.value ? dodDrawer.value.AccountsVisible : false;
});

const all_chart_types = [{
  value: "bar",
  text: "Bar"
}, {
  value: "line",
  text: "Line"
}, {
  value: "doughnut",
  text: "Doughnut"
}, {
  value: "pie",
  text: "Pie"
}]


const buttons = computed(() => {
    var btns = [];
    btns.push({ id:'ToggleAccountsBtn', icon: icons.report_icons.toggle_accounts, click: ToggleAllAccounts, disabled: false, active: is_accounts_visible.value, tooltip: is_accounts_visible.value ? 'Dölj konton' : 'Visa konton' });
    btns.push({ id:'ToggleDecimalsBtn', icon: icons.report_icons.toggle_decimals, click: ToggleDecimals, disabled: false, active: is_decimals_visible.value, tooltip: is_decimals_visible.value ? 'Dölj decimaler': 'Visa decimaler' });
    btns.push({ id:'ZoomInBtn', icon: icons.report_icons.zoom_in, click: ZoomIn, disabled: false, tooltip: 'Zoom_In' });
    btns.push({ id:'ZoomResetBtn', icon: icons.report_icons.zoom_reset, click: ZoomReset, disabled: false, tooltip: 'Zoom_Reset' });
    btns.push({ id:'ZoomOutBtn', icon: icons.report_icons.zoom_out, click: ZoomOut, disabled: false, tooltip: 'Zoom_Out' });    
    /// btns.push({ id:'DownloadBtn', icon: icons.document_icons.download, click: downloadDocument, disabled: false, tooltip: 'Download' });
    // btns.push({ id:'PrintBtn', icon: icons.document_icons.print, click: printDocument, disabled: false, tooltip: 'Print' });
    // btns.push({ id:'OpenExternal', icon: icons.document_icons.external, click: open, disabled: false, tooltip: 'Open_External' });

    return btns;
})

onMounted(async () => {
  
  // Add event listener for graphs
  window.reportShowGraph = ShowGraph;
  // add event listener for draw complete
  window.reportDrawComplete = DrawComplete;
  
  // Dynamically load JavaScript files
  await loadScript("/dod/report/dod_report_constants.js");
  await loadScript("/dod/report/dod_report_helper.js");
  await loadScript("/dod/report/dod_report_drawer.js");

  // Wait until scripts are loaded before running the report
  if (window.dod_report_helper && window.dod_report_drawer) {
    console.log("Scripts loaded successfully.");

    // Load report data
    const reportData = await window.dod_report_helper.LoadReport(props.report_url, props.data_url);

    // Initialize and draw the report inside the Vue component
    dodDrawer.value = new window.dod_report_drawer(reportData, reportContainer.value);
    dodDrawer.value.DrawReport();
  } else {
    console.error("Failed to load report scripts.");
  }  

});

function DrawComplete() {
  reportOverflow.value.SetScroll();
}

function ShowGraph(type, chart)
{
  chart_chart.value = chart;
  chart_type.value = type;
  graphModal.value.Open();
}

// Function to dynamically load scripts
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(`Failed to load script: ${src}`);
    document.head.appendChild(script);
  });
}

function ToggleAllAccounts() {
  dodDrawer.value.ToggleAllAccounts();
}

function ToggleDecimals() {
  dodDrawer.value.ToggleDecimals();
}

function ZoomIn() {
  dodDrawer.value.ChangeFontSize('increase');
}
function ZoomOut() {
  dodDrawer.value.ChangeFontSize('decrease');
}
function ZoomReset() {
  dodDrawer.value.ChangeFontSize('reset');
}

</script>






<!-- <template>
    <iframe :src="computedIframeSrc" style="width: 100%; height: 100vh; border: none;"></iframe>
  </template>
  
  <script setup>
  import { computed, defineProps} from "vue";
  
  // Ta emot props för data_url och report_url
  const props = defineProps({
    data_url: String,
    report_url: String
  });
  
  // Skapa computed property för att kombinera URL-parametrarna
  const computedIframeSrc = computed(() => {
    const baseUrl = '/dod/report/dod_report_viewer.html'; // bas-URL för iframe
    const reportParam = `r=${encodeURIComponent(props.report_url)}`;
    const dataParam = `d=${encodeURIComponent(props.data_url)}`;
  
    return `${baseUrl}?${reportParam}&${dataParam}`;
  });
  </script> -->